// What the Software tab of a machine shows, worked out from the software fact (the programs Get-InstalledPrograms reported) and the machine's open
// findings, so the page only lays it out.

const list = (v) => (Array.isArray(v) ? v : []);
const has = (v) => v !== null && v !== undefined && String(v).trim() !== '';

// The words for a program's scope: 'machine' installs are machine-wide.
export const scopeWords = (scope) => (String(scope || 'machine').toLowerCase() === 'user' ? 'Per user' : 'Machine-wide');

// What a policy would name a program by: its winget id, else its name made safe for the API's program parameter (letters, digits and . _ : @ | # ~ + - and spaces).
export const programKey = (p) => {
  if (has(p && p.id)) return String(p.id).trim();
  const name = String((p && p.name) || '').replace(/[^A-Za-z0-9_.:@|#~ +-]/g, '_').trim().replace(/^[^A-Za-z0-9]+/, '');
  return name.slice(0, 200);
};

// The open findings that are about a program of this machine: by its winget id (the finding's subject), else by the name it is installed as.
const aboutProgram = (f, p) => f && f.capability === 'software' && ((has(p.id) && f.subject === p.id) || (f.detail && f.detail.name === p.name) || (!has(p.id) && f.subjectName === p.name));

// [{key, name, version, publisher, id, scope, thirdParty, findings}] in name order, one row for each installed program. A program with no type
// is counted as third party (nothing says it is Microsoft's or the operating system's).
export const programRows = (programs, findings) => list(programs)
  .filter((p) => p && has(p.name))
  .map((p) => ({
    key: `${p.id || ''}|${p.name}|${p.version || ''}`, name: String(p.name), version: has(p.version) ? String(p.version) : '', publisher: has(p.publisher) ? String(p.publisher) : '',
    id: has(p.id) ? String(p.id) : '', scope: scopeWords(p.scope), thirdParty: !has(p.programType) || String(p.programType).toLowerCase() === 'thirdparty',
    findings: list(findings).filter((f) => aboutProgram(f, p)),
  }))
  .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()) || a.version.localeCompare(b.version));

// The rows the person asked to see: every word typed is in the name, publisher or id; third party only leaves out Microsoft and operating system programs.
export const filterRows = (rows, { text = '', thirdParty = false } = {}) => {
  const words = text.trim().toLowerCase().split(/\s+/).filter(Boolean);
  return rows.filter((r) => (!thirdParty || r.thirdParty) && words.every((w) => `${r.name} ${r.publisher} ${r.id}`.toLowerCase().includes(w)));
};
